import { useQuery } from "@tanstack/react-query";
import { TONE, type Tone } from "@recursive-staff/ui";
import { api } from "../api";
import { ErrorNote, Loading, Page } from "./common";

export function Board() {
  const { data, isLoading, error } = useQuery({ queryKey: ["board"], queryFn: api.board });
  if (isLoading) return <Loading />;
  if (error || !data) return <ErrorNote error={error} />;

  return (
    <Page>
      <div>
        <h1 style={{ margin: 0, fontSize: 24, fontWeight: 600, letterSpacing: "-0.6px" }}>Delivery board</h1>
        <div style={{ fontSize: 14, color: "#8a8e88", marginTop: 3 }}>Escalated tickets moving through Survey’s issue FSM</div>
      </div>
      <div style={{ display: "flex", gap: 12, overflowX: "auto", paddingBottom: 8, flex: 1, alignItems: "flex-start" }}>
        {data.columns.map((col) => {
          const issues = data.issues.filter((i) => i.column === col.id);
          return (
            <div key={col.id} style={{ minWidth: 260, width: 260, flex: "none", background: "#f6f5f1", borderRadius: 6, padding: 10, border: "1px solid #ececec" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "2px 4px 10px" }}>
                <span style={{ fontSize: 11, fontWeight: 600, letterSpacing: ".8px", textTransform: "uppercase", color: "#6b706a" }}>{col.label}</span>
                <span style={{ fontSize: 11, fontFamily: "'Space Mono',monospace", color: "#8a8e88" }}>{issues.length}</span>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                {issues.map((i, idx) => (
                  <div key={`${i.key}-${idx}`} style={{ background: "#fff", borderRadius: 4, boxShadow: "inset 0 0 0 1px rgba(0,0,0,.07)", padding: "10px 11px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 6 }}>
                      <span style={{ fontFamily: "'Space Mono',monospace", fontSize: 10.5, fontWeight: 700, color: i.key === "—" ? "#bcbfba" : "#006747" }}>{i.key}</span>
                      {i.pr && <span style={{ fontFamily: "'Space Mono',monospace", fontSize: 10, color: "#2a6f8a" }}>{i.pr}</span>}
                      <div style={{ flex: 1 }} />
                      <span style={{ fontSize: 10, fontWeight: 600, color: "#16243a", background: "#e8ebf0", borderRadius: 3, padding: "1px 6px" }}>{i.clientName}</span>
                    </div>
                    <div style={{ fontSize: 12.5, fontWeight: 500, lineHeight: 1.4 }}>{i.title}</div>
                    <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 8 }}>
                      <span style={{ fontFamily: "'Space Mono',monospace", fontSize: 10.5, color: "#8a8e88" }}>{i.ticketId}</span>
                      <div style={{ flex: 1 }} />
                      <span style={{ fontSize: 10, fontWeight: 600, padding: "2px 7px", borderRadius: 999, background: TONE[i.tone as Tone].bg, color: TONE[i.tone as Tone].fg }}>{i.status}</span>
                    </div>
                  </div>
                ))}
                {issues.length === 0 && <div style={{ fontSize: 12, color: "#bcbfba", padding: "6px 4px" }}>—</div>}
              </div>
            </div>
          );
        })}
      </div>
    </Page>
  );
}
